
// Add "7 USD /Sq ft" to collection page if english
var pathName = window.location.pathname;
var pathParts= pathName.split("/");

//om denna pathen så lägg till text under priset på collectionsidan
if(pathParts.length > 1 && pathParts[0] == '' && pathParts[1] == 'collections') {
   
  var counter = 0;
  var checkExist = setInterval(function() {
    
   	 counter++;
     
     // väntar på att grid-product__meta elementet har skapats
     if ($('.grid-product__meta').length) {
       
       // lägger till ett <div> element under grid-product__meta
       $('.grid-product__meta').append('<div class="SqFtCollectionGrid">7 USD / Sq ft</div>');
       
        clearInterval(checkExist);
     }
    
    // slutar vänta efter 5 sekunder
    if(counter > 50) {
    	clearInterval(checkExist);
    }
    
  }, 100); // check every 100ms
    
}
